import React from 'react';

const MobileNavItem = ({ slNo, navInfo, setShow ,toggleDropDown}) => {

    return (
        <div className="accordion-item border-0">
            <h2 className="accordion-header " id={`flush-heading${slNo}`}>
                {slNo === 4 ?
                    <span className="toggle-bg d-block m-0 pb-2 ">
                        <a
                            onClick={() => setShow(false)}
                            href={navInfo?.drop_nav1_link}
                            className="dropless-link "
                        >
                            {navInfo?.nav_name}
                        </a>
                    </span> :
                    slNo === 6 ?
                        <span className="toggle-bg d-block m-0 pb-3">
                            <a
                                onClick={() => setShow(false)}
                                href={navInfo?.drop_nav1_link}
                                className="dropless-link  "
                            >
                                {navInfo?.nav_name}
                            </a>
                        </span> :
                        <button className="accordion-button toggle-bg   collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-collapse${slNo}`} aria-expanded="false" aria-controls={`flush-collapse${slNo}`}>
                            {navInfo?.nav_name}
                        </button>
                }

            </h2>
            <div id={`flush-collapse${slNo}`} className=" accordion-collapse collapse" aria-labelledby={`flush-heading${slNo}`} data-bs-parent="#accordionFlushExample">
                <ul className="list-unstyled mobile-nav-items ">
                    <li><a onClick={() => toggleDropDown(navInfo?.drop_nav1,slNo)} href={navInfo?.drop_nav1_link}>{navInfo?.drop_nav1}</a></li>
                    <li><a onClick={() => toggleDropDown(navInfo?.drop_nav2,slNo)} href={navInfo?.drop_nav2_link}>{navInfo?.drop_nav2}</a></li>
                    <li><a onClick={() => toggleDropDown(navInfo?.drop_nav3,slNo)} href={navInfo?.drop_nav3_link}>{navInfo?.drop_nav3}</a></li>
                    {navInfo?.drop_nav4 && <li><a onClick={() => toggleDropDown(navInfo?.drop_nav4,slNo)} href={navInfo?.drop_nav4_link}>{navInfo?.drop_nav4}</a></li>}
                    {navInfo?.drop_nav5 && <li><a onClick={() => toggleDropDown(navInfo?.drop_nav5,slNo)} href={navInfo?.drop_nav5_link}>{navInfo?.drop_nav5}</a></li>}
                    {navInfo?.drop_nav6 && <li><a onClick={() => setShow(false)} href={navInfo?.drop_nav6_link}>{navInfo?.drop_nav6}</a></li>}
                    {navInfo?.drop_nav7 && <li><a onClick={() => setShow(false)} href={navInfo?.drop_nav7_link}>{navInfo?.drop_nav7}</a></li>}
                    {navInfo?.drop_nav8 && <li><a onClick={() => setShow(false)} href={navInfo?.drop_nav8_link}>{navInfo?.drop_nav8}</a></li>}

                </ul>
            </div>
        </div>
    );
};

export default MobileNavItem;